import Work1 from "../../assets/work-1.svg"
import Work2 from "../../assets/work-2.svg"
import Work3 from "../../assets/work-3.svg"
import Work4 from "../../assets/work-4.svg"
import Work5 from "../../assets/work-5.svg"
import Work6 from "../../assets/work-6.svg"
import KiloHealth from "../../assets/KiloHealth.png"
import Park from "../../assets/park2.png"
import MovieAPI from "../../assets/Movie.png"

const Menu = [
    {
      id: 1,
      image: KiloHealth,
      title: "Kilo Health Admin Dashboard",
      category: "API",
      link:"https://github.com/CHHORNSeyha88/kilo-health-admin"
    },
    {
      id: 2,
      image: Park,
      title: "Upcoming Soon!!",
      category: "Web",
      link:""
    },
    {
      id: 3,
      image: MovieAPI,
      title: "MovieFlex-Poster API",
      category: "API",
      link:"https://github.com/CHHORNSeyha88/movie-poster-api"
    },
    ,
    {
      id: 4,
      image: Work4,
      title: "Upcoming Soon!!",
      category: "Design",
      link:""

    },
    ,
    {
      id: 5,
      image: Work5,
      title: "Upcoming Soon!!",
      category: "Creative",
      link:""

    },
    ,
    {
      id: 6,
      image: Work6,
      title: "Upcoming Soon!!",
      category: "Web",
      link:""

    },
    {
      id: 7,
      image: Work6,
      title: "Upcoming Soon!!",
      category: "Web",
      link:""

    },
    {
      id: 8,
      image: Work6,
      title: "Upcoming Soon!!",
      category: "Web",
      link:""

    },
    {
      id: 9,
      image: Work6,
      title: "Upcoming Soon!!",
      category: "API",
      link:""

    },
    {
      id: 10,
      image: Work6,
      title: "Upcoming Soon!!",
      category: "Design",
      link:""

    },
    {
      id: 11,
      image: Work6,
      title: "Upcoming Soon!!",
      category: "Art",
      link:""

    },
    {
      id: 12,
      image: Work6,
      title: "Upcoming Soon!!",
      category: "Art",
      link:""

    },
    {
      id: 13,
      image: Work6,
      title: "Upcoming Soon!!",
      category: "API",
      link:""

    },
  ];
  

export default Menu;